import { Button, type IButtonProps } from 'shared/ui'
import { ChatbotPath } from 'entities/ExportRouters'

type ICreateNewAIAgentProps = {
  onCloseMenu?: () => void
} & IButtonProps

export const CreateNewAIAgent = ({ onCloseMenu, ...props }: ICreateNewAIAgentProps) => {
  const handleNewAgent = () => {
    onCloseMenu?.()
    window.open(`${ChatbotPath.texting}?showCreateModal=true`, '_blank', 'noopener,noreferrer')
  }
  return (
    <Button
      text={'New agent'}
      aria-label={'New agent'}
      icon={'add'}
      fullWidth
      typeBtn={'menuItem'}
      onClick={handleNewAgent}
      {...props}
    />
  )
}
